import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchScanHistory = createAction(ACTION.GET_SCAN_BARCODE_HISTORY.REQUEST, (params) => params);
export const clearScanHistory = createAction(ACTION.CLEAR_SCAN_BARCODE_HISTORY.REQUEST, (params) => params);